// components/layout/Header.jsx
import styled from "styled-components";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import { ROLES } from "../../utils/authRoles";

const HeaderBar = styled.div`
  height: 60px;
  background: ${({ theme }) => theme.colors.surface};
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 16px;

  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;

  width: 100%;
  overflow-x: hidden;
  transition: box-shadow 0.3s ease;

  ${({ scrolled }) =>
    scrolled &&
    `
    box-shadow: 0 4px 12px rgba(0,0,0,0.1);
  `}
`;

const Left = styled.div`
  display: flex;
  align-items: center;
  gap: 14px;
  flex-shrink: 1;
  min-width: 0;
`;

const MenuBtn = styled.button`
  font-size: 22px;
  background: none;
  border: none;
  cursor: pointer;

  @media (min-width: 992px) {
    display: none;
  }
`;

const TitleBlock = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 0;
  overflow: hidden;

  @media (min-width: 992px) {
    flex-direction: row;
    align-items: center;
    gap: 10px;
  }
`;

const Title = styled.span`
  font-weight: 600;
  font-size: 16px;
  color: ${({ theme }) => theme.colors.textPrimary};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  @media (max-width: 600px) {
    font-size: 14px;
  }
`;

const Branch = styled.span`
  font-size: 13px;
  color: ${({ theme }) => theme.colors.textSecondary};
  white-space: nowrap;

  @media (min-width: 992px) {
    border-left: 1px solid ${({ theme }) => theme.colors.border};
    padding-left: 10px;
  }
`;

const RightSection = styled.div`
  display: flex;
  align-items: center;
  gap: 18px;
  flex-shrink: 0;
`;

const IconBtn = styled.button`
  background: none;
  border: none;
  font-size: 18px;
  cursor: pointer;
  position: relative;
`;

const NotificationDot = styled.span`
  position: absolute;
  top: -4px;
  right: -4px;
  width: 8px;
  height: 8px;
  background: ${({ theme }) => theme.colors.danger};
  border-radius: 50%;
`;

const UserName = styled.span`
  font-size: 14px;
  color: ${({ theme }) => theme.colors.textPrimary};

  @media (max-width: 600px) {
    display: none;
  }
`;

const LogoutBtn = styled.button`
  border: none;
  background: ${({ theme }) => theme.colors.accent || '#007bff'};
  color: ${({ theme }) => theme.colors.secondary || '#fff'};
  border-radius: 6px;
  padding: 6px 10px;
  cursor: pointer;
  font-size: 12px;
  font-weight: 500;
`;

export default function Header({ toggle }) {
  const [scrolled, setScrolled] = useState(false);
  const navigate = useNavigate();
  const { authUser, logout } = useAuth();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 10);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleLogout = async () => {
    await logout();
    navigate("/login", { replace: true });
  };

  const roleLabel =
    authUser?.role === ROLES.SUB_ADMIN ? "Sub Admin" : "Admin";

  return (
    <HeaderBar scrolled={scrolled}>
      {/* LEFT */}
      <Left>
        <MenuBtn onClick={toggle}>☰</MenuBtn>

        <TitleBlock>
          <Title>MAPS ASSOCIATES - Gold Loan System</Title>
          <Branch>Tirunelveli Branch</Branch>
        </TitleBlock>
      </Left>

      {/* RIGHT */}
      <RightSection>
        <IconBtn>
          🔔
          <NotificationDot />
        </IconBtn>

        <UserName>{authUser?.email || roleLabel}</UserName>

        <IconBtn>
          👤
        </IconBtn>

        <LogoutBtn onClick={handleLogout}>Logout</LogoutBtn>
      </RightSection>
    </HeaderBar>
  );
}